import clsx from "clsx";
import { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  order?: 1 | 2 | 3;
}

const Title: FC<Props> = ({ children, className, order = 1 }) => {
  return (
    <div
      className={clsx(className, "text-slate-900 font-bold leading-8 md:leading-6", {
        "text-2xl md:text-3xl": order === 1,
        "text-xl md:text-2xl": order === 2,
        "text-lg md:text-xl": order === 3,
      })}
    >
      {children}
    </div>
  );
};

export default Title;
